/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface ConfirmationErrorRequest {

    /**
     * User-readable explanation of the error.
     */
    error?: string;

    /**
     * Stable computer-readable explanation of the error.
     */
    code?: string;

    /**
     * User ID to use when submitting a new confirmation request.
     */
    user_id?: number;

}

@Model('ConfirmationError')
export class ApiConfirmationError extends BaseModel implements ConfirmationErrorRequest {

    /**
     * User-readable explanation of the error.
     */
    
    
    error: string;

    /**
     * Stable computer-readable explanation of the error.
     */
    
    
    code: string;

    /**
     * User ID to use when submitting a new confirmation request.
     */
    
    
    user_id: number;

}
